import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Modal from '@mui/material/Modal';
import PropTypes from 'prop-types';
import ImportModalSuccessView from './ExportModalSuccessView';
import ImportModalFailureView from './ExportModalFailureView';
import ImportModalInProgressView from './ExportModalInProgressView';
import './styles.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

export default function ExportModal({
  open,
  isTxnCompleted,
  successFlag,
  totalCount,
  onPopupClose,
  errorMsg
}) {
  const handleClose = () => {
    onPopupClose();
  };

  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          {isTxnCompleted == false && <ImportModalInProgressView />}
          {isTxnCompleted == true && successFlag == true && (
            <ImportModalSuccessView totalCount={totalCount} />
          )}
          {isTxnCompleted == true && successFlag == false && (
            <ImportModalFailureView reason={errorMsg} />
          )}
          {isTxnCompleted == true && (
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{ color: 'white', background: '#01a8c4', marginTop: '5vh' }}>
              OK
            </Button>
          )}
        </Box>
      </Modal>
    </div>
  );
}

ExportModal.propTypes = {
  open: PropTypes.bool,
  isTxnCompleted: PropTypes.bool,
  successFlag: PropTypes.bool,
  totalCount: PropTypes.number,
  onPopupClose: PropTypes.func,
  errorMsg: PropTypes.string
};
